import Vue from 'vue'
import App from './App.vue'
import router from './router'
import GoEasy from 'goeasy';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false


Vue.prototype.globalData = {
    currentAgent: null
};

new Vue({
  router,
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this
  }
}).$mount('#app')

const goEasy = GoEasy.getInstance({
	host: 'hangzhou.goeasy.io',	//应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
	appkey: 'BC-9350be8a24804bc99f35c961bdd8bdf8', // key,
	modules: ['im']
});
// appkey: 'BC-9350be8a24804bc99f35c961bdd8bdf8', // 正式 key,
// 	appkey: 'BC-b48dca92e00a49cd8299fa551bc86a27', // 测试 key,
Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;

